



import React, {useState,useEffect} from 'react';
// import { useHistory } from 'react-router-dom';
import { useLocation,useNavigate } from 'react-router-dom';


import "./Courses.css"
import NavBar from '../../Components/NavBar/NavBar';
import CourseSpot from '../../Components/CourseSpot/CourseSpot';
import Footer from '../../Components/Footer/Footer';
import Faqs from '../../Components/FAQs/FAQs';
import CourseCarousel from '../../Components/CourseCarousel/CourseCarousel';
import ScrollToTop from '../../Components/ScrollTop/ScroolTop';
import { useParams } from 'react-router-dom';
import MoreInfoSection  from "../../Components/MoreInfoSection/MoreInfoSection"



function Courses({onButtonClick}) { 

  // const history = useLocation();

  // useEffect(() => {
  //   const unlisten = useNavigate.listen(() => {
  //     window.scrollTo(0, 0);

  //     console.log("recab")
  //   });

  //   return () => unlisten();
  // }, [history]);
  
  let {CID} = useParams()
 

  return <>
        <div className='CoursesContainer'>
                <ScrollToTop/>
                <NavBar/>
                <CourseSpot onButtonClick ={onButtonClick} courseID={CID}/>

                
                <MoreInfoSection courseID={CID}/>
                {/* <CourseCarousel/> */}
                <Faqs/>
                <Footer/>
                
        </div>
       
    
  </>
  
  ;
}

export default Courses;